"use strict";

angular.module("vendor")
.component("catalogEntryVariants", {
    templateUrl: require("./catalog-entry-variants.component.html"),
    controller: catalogEntryVariantsController,
    controllerAs: "catalogEntryVariantsCtrl",
    bindings: {
        catalogEntry: "=",
        isInventoryAvailable: "<",
        variantOptions: "<"
    }
});

function catalogEntryVariantsController(
    $scope, $interval, gettextCatalog, Language, FlashBag, PatternService, ProductService, CoreProductVariantService,
    CatalogEntryVariantsService, CATALOG_HEADER_OFFSET
) {
    var _this = this;
    $scope.INVENTORY_QUANTITY_MAX = ProductService.INVENTORY_QUANTITY_MAX;
    $scope.pattern = PatternService;
    $scope.catalogEntryVariantsService = CatalogEntryVariantsService;

    Language.initializeScope($scope, "language", "locale");

    this.getProductVariantName = function(optionValues) {
        return CoreProductVariantService.getProductVariantName(_this.variantOptions, optionValues);
    };

    this.onDeleteCatalogEntryVariant = function() {
        FlashBag.alertWithContainer(
            "success", "catalog-entry",
            gettextCatalog.getString("The catalog entry variant has successfully been deleted.")
        );
        $(window).scrollTop($("[name=catalog-entry]").offset().top + CATALOG_HEADER_OFFSET);
        $scope.$emit("fetchCatalogEntries");
        $scope.$emit("updateWizardMenu");
    };

    this.updateCatalogEntryVariantState = function(catalogEntryVariant) {
        CatalogEntryVariantsService.patchField(catalogEntryVariant.id, {enabled: catalogEntryVariant.enabled})
        .then(function onSuccess() {
            $scope.$emit("updateWizardMenu");
        });
    };

    this.updateCatalogEntryVariantInventoryQuantity = function(form, catalogEntryVariant) {
        if (catalogEntryVariant.initial_inventory_quantity === catalogEntryVariant.inventory_quantity || !form.$valid) {
            return;
        }

        CatalogEntryVariantsService.patchField(
            catalogEntryVariant.id,
            {inventory_quantity: catalogEntryVariant.inventory_quantity}
        ).then(function onSuccess(data) {
            catalogEntryVariant.inventoryQuantitySaved = true;
            catalogEntryVariant.initial_inventory_quantity = data.initial_inventory_quantity;
            form.$setPristine();

            $interval(function() {
                catalogEntryVariant.inventoryQuantitySaved = false;
            }, FlashBag.getSuccessMessageLifetime(), 1);
        }, function onError(response) {
            FlashBag.apiError(response);
        });
    };

    this.updateCatalogEntryVariantPrice = function(form, catalogEntryVariant) {
        if (
            parseFloat(catalogEntryVariant.initial_price).toFixed(5) === parseFloat(catalogEntryVariant.price).toFixed(5)
            || !form.$valid
        ) {
            return;
        }

        CatalogEntryVariantsService.patchField(catalogEntryVariant.id, {price: catalogEntryVariant.price}).then(
            function(data) {
                catalogEntryVariant.priceSaved = true;
                catalogEntryVariant.initial_price = data.initial_price;
                form.$setPristine();

                $interval(function() {
                    catalogEntryVariant.priceSaved = false;
                }, FlashBag.getSuccessMessageLifetime(), 1);
            }
        );
    };
}



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/catalog/catalog-entry-tab/catalog-entry-variants/catalog-entry-variants.component.js
// module id = 960
// module chunks = 0